import styles from '@styles/Loading.module.css'

const Loading = () => {
  return (
    <div className={styles.loading}>
      Cargando <span className={styles.loader36}></span>
    </div>
  )
}

export default Loading
